import { Link } from 'react-router-dom';
import React from 'react';
import { brand } from 'images';
import { Nav, Navbar } from 'react-bootstrap';

const PublicReportsAppHeader = () => {
  return (
    <Navbar className={`app-header public-header justify-content-between`} collapseOnSelect expand="lg">
      <Navbar.Brand>
        <Link to={`/dashboard`}>
          <img src={brand['logo-header-reporting']} height="40" className="d-inline-block align-top" alt="LeadLoop logo" />
        </Link>
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav">
        <div className="app-header-left" />
        <div className="app-header-center" />
        <div className="app-header-right">
          <Navbar id="responsive-navbar-nav">
            <Nav>
              <Link className={'nav-link'} to={`/login`}>
                Login
              </Link>
            </Nav>
          </Navbar>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default PublicReportsAppHeader;
